import axios from '../utils/axios';

export default function fetchJobPremiumData(adminId, params) {
    return (
        axios.get(`/admin/${adminId}/job-premium-data`, { params } )
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
